import React from "react";
import { Link } from "react-router-dom";

/** Shared auth-page chrome — cinematic dossier framing. */
export const AuthShell = ({ title, lead, children, footer }) => (
  <div className="min-h-screen flex items-center justify-center px-4 py-10"
       style={{ backgroundColor: "#08070A" }}>
    <div className="w-full max-w-md relative">
      {/* Crosshair corners */}
      <span aria-hidden className="absolute -top-3 -left-3 w-4 h-4 border-l border-t" style={{ borderColor: "#454038" }} />
      <span aria-hidden className="absolute -top-3 -right-3 w-4 h-4 border-r border-t" style={{ borderColor: "#454038" }} />
      <span aria-hidden className="absolute -bottom-3 -left-3 w-4 h-4 border-l border-b" style={{ borderColor: "#454038" }} />
      <span aria-hidden className="absolute -bottom-3 -right-3 w-4 h-4 border-r border-b" style={{ borderColor: "#454038" }} />

      <div className="border p-7" style={{ borderColor: "#2D2A26", backgroundColor: "#0F0E12" }}>
        <div className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#D92D20]">
          // THE ARCHIVE · SECURE CHANNEL
        </div>
        <h1 className="font-display text-2xl sm:text-3xl mt-3 text-[#E4DFD3] leading-tight">
          {title}
        </h1>
        {lead && (
          <p className="text-sm mt-3 text-[#A39E93] leading-relaxed">{lead}</p>
        )}
        <div className="mt-6">{children}</div>
        {footer && (
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#6F6A60] mt-6 pt-4 border-t" style={{ borderColor: "#2D2A26" }}>
            {footer}
          </div>
        )}
      </div>
      <div className="font-mono text-[9px] uppercase tracking-[0.4em] text-[#6F6A60] text-center mt-4">
        <Link to="/" className="hover:text-[#D92D20]">// Return to Archive</Link>
      </div>
    </div>
  </div>
);

export const Field = ({ label, type = "text", value, onChange, autoComplete, required, "data-testid": testid, name, autoFocus }) => (
  <label className="block mb-4">
    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A39E93]">{label}</span>
    <input
      type={type}
      value={value}
      name={name}
      onChange={(e) => onChange(e.target.value)}
      autoComplete={autoComplete}
      required={required}
      autoFocus={autoFocus}
      data-testid={testid}
      className="mt-2 w-full bg-[#08070A] border px-3 py-2 text-sm text-[#E4DFD3] font-mono focus:outline-none focus:border-[#D92D20]"
      style={{ borderColor: "#454038" }}
    />
  </label>
);

export const PrimaryBtn = ({ children, type = "submit", disabled, onClick, "data-testid": testid }) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    data-testid={testid}
    className="w-full font-mono text-[11px] uppercase tracking-[0.35em] py-2.5 disabled:opacity-50"
    style={{ background: "#D92D20", color: "#fff" }}
  >
    {children}
  </button>
);

export const SmallLink = ({ to, children, "data-testid": testid }) => (
  <Link to={to} data-testid={testid}
        className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#9FA8D4] hover:text-[#D92D20]">
    {children}
  </Link>
);

export const Notice = ({ kind = "info", children, "data-testid": testid }) => {
  const color = kind === "error" ? "#D92D20" : kind === "success" ? "#5DD4B3" : "#9FA8D4";
  return (
    <div data-testid={testid}
         className="font-mono text-[11px] leading-relaxed border p-3 mb-4"
         style={{ borderColor: color + "66", color, backgroundColor: "rgba(0,0,0,0.3)" }}>
      {children}
    </div>
  );
};
